import { Role } from '../../../types/Role';
import { RoleService } from '../../user/session/RoleService';

export const getRole = (): Role => RoleService.getInstance().get();
// this is just an alias for old references, it's not actually a hook atm.
// has to be written in an arrow fn, otherwise knip will complain.
export const useRole = () => getRole();
